export default "__VITE_ASSET__CAAc8cFs__"